(function () {
    'use strict';

    angular.module('ib-passenger-basic-info-module')
        .controller('PassengerBasicInfoController', PassengerBasicInfoController);

    PassengerBasicInfoController.$inject = ['CheckinAppConstants', '$scope'];
    function PassengerBasicInfoController (CheckinAppConstants, $scope) {
        const vm = this;

        vm.$onInit = activate;
        vm.getYearsByType = getYearsByType;
        vm.isRequiredField = isRequiredField;
        vm.changeNationality = changeNationality;

        ////////////////

        function activate () {
            vm.requiredFields = vm.requiredFields || [];
        }

        function getYearsByType (type, isFrom) {
            let years;
            switch (type) {
                    case CheckinAppConstants.PASSENGERS_TYPES.CHILD: years = isFrom ? 2 : 12; break;
                    case CheckinAppConstants.PASSENGERS_TYPES.INFANT: years = isFrom ? 0 : 2; break;
                    case CheckinAppConstants.PASSENGERS_TYPES.ADULT:
                    default: years = isFrom ? 0 : 100; break;
            }
            return years;
        }

        function isRequiredField (field) {
            return vm.requiredFields.indexOf(field) !== -1;
        }

        function changeNationality () {
            $scope.$emit('nationalityChange');
        }
    }
})();